import React from 'react'
import { Table } from 'antd'
import { defaultPagination } from '../../../../services/api/client/types'
import { ManOutlined, WomanOutlined } from '@ant-design/icons'
import { isMale } from '../../../../utils/types'
import { employeePath } from '../../../../routes/paths'
import { EmployeeListItem } from '../../../../services/api/employees'
import { useHistory } from 'react-router-dom'
import locales from '../../../../assets/locales.json'
import { displayDate } from '../../../../utils/formatter'
import { safePrintValue } from '../../../../utils'

type Props = {
  data?: EmployeeListItem[]
  meta?: {
    page: number | null
    perPage: number | null
    totalCount?: number
  }
  isLoading: boolean
  onPaginationChange: (page: number, perPage?: number) => void
}

export const EmployeesTable: React.FunctionComponent<Props> = ({
  isLoading,
  data,
  meta,
  onPaginationChange,
}) => {
  const history = useHistory()
  const countries = locales.ru.countries

  return (
    <Table
      dataSource={data}
      columns={[
        {
          title: 'ФИО',
          render: (_, employee) =>
            `${employee.firstNameRu} ${employee.lastNameRu}`,
        },
        {
          title: 'ФИО (на английском)',
          render: (_, employee) =>
            `${employee.firstNameEn} ${employee.lastNameEn}`,
        },
        {
          title: 'Гражданство',
          render: (_, employee) =>
            countries[employee.countryCode as keyof typeof countries],
        },
        {
          title: 'Пол',
          render: (_, employee) =>
            isMale(employee.gender) ? <ManOutlined /> : <WomanOutlined />,
        },
        {
          title: 'Дата рождения',
          render: (_, employee) => displayDate(employee.birthdate),
        },
        {
          title: 'Email',
          render: (_, employee) => safePrintValue(employee.email),
        },
      ]}
      loading={isLoading}
      pagination={{
        onChange: onPaginationChange,
        current: meta?.page || defaultPagination.page,
        pageSize: meta?.perPage || defaultPagination.perPage,
        total: meta?.totalCount,
        defaultCurrent: defaultPagination.page,
        defaultPageSize: defaultPagination.perPage,
      }}
      rowKey={(employee) => employee.id}
      onRow={(employee) => {
        return {
          onClick: () => {
            history.push(employeePath(employee.id))
          },
        }
      }}
    />
  )
}
